import React, { useState } from 'react'
import UomsForm from './UomsForm'
import { useParams } from 'react-router-dom';

const EditUomPage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentUomId?(<UomsForm formType='edit' currentUomId={id} ></UomsForm>):''
     
    </>
  )
}

export default EditUomPage
